import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ArtifactCardNode from './ArtifactCardNode.vue'

export default Node.create({
  name: 'artifact-card',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      artifactId: {
        default: null,
        parseHTML: element => element.getAttribute('artifact-id'),
        renderHTML: attributes => ({ 'artifact-id': attributes.artifactId }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'artifact-card' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['artifact-card', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(ArtifactCardNode)
  },
})
